import type { IconData } from '@stacksjs/iconify-core'

export const endPointDiamond: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M2 21h21.217c2.2 0 4.14.005 5.847.014a87 87 0 0 1 2.24-2.317a75 75 0 0 1 3.647-3.44a2.48 2.48 0 0 1 3.311 0c.872.762 2.088 1.88 3.648 3.44a75 75 0 0 1 3.44 3.648a2.48 2.48 0 0 1 0 3.31a75 75 0 0 1-3.44 3.648a75 75 0 0 1-3.648 3.44a2.48 2.48 0 0 1-3.31 0a75 75 0 0 1-3.649-3.44a87 87 0 0 1-2.239-2.318c-1.708.01-3.647.015-5.847.015H2\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default endPointDiamond
